import React, { useCallback, useEffect, useState, useRef, createElement, Component } from 'react';
import { Check, Star, AlertTriangle, Hammer, BookOpen, ShieldCheck, Lock, CreditCard, Wrench, Layout, ChevronDown, Zap, Download, HelpCircle, Brain, DollarSign, MessageSquare, X } from 'lucide-react';
// --- Constants & Data ---
// NEW ebook mockup image
const MAIN_PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/a53GoZChi4D4KXXg2vPEsN/naQNb_l4Tge_o_3mPcStbw2k.webp';
const UPSELL_IMG = 'https://cdn.magicpatterns.com/uploads/vsVJCiuQS3GULfBmGD1oQN/7dbaf1c0-f1e2-42ec-b29e-4275343a4aeb.png';
// NEW bundle image for CompactAccessSection
const BUNDLE_HERO_IMG = 'https://cdn.magicpatterns.com/uploads/eZ9vqieemzRzScwfScAkC3/_bWADyqANS36Osq2xWSZ4ag_Uhd7XL9ASTiwWyQ4L3RkFA_4k.png';
// Trust badges images
const MERCADO_PAGO_IMG = 'https://cdn.magicpatterns.com/uploads/xm4qavEQc5iVme5Wmyo3hK/medios-de-pago-640x640.png';
// Codex Labs logo
const CODEX_LABS_LOGO = 'https://cdn.magicpatterns.com/uploads/uqsnXk34KqPGVvt4pPdYDs/editorial-logo-for-codex-labs-white-back_SxqASZhLS8y26rsqt9u5YQ_rigTUS2pS3S3p3O59ErBjg_hd.png';
// Checkout URLs
const MAIN_CHECKOUT_URL = 'https://checkout.maestrosindustriales.shop/cart/47957399109880:1';
const UPSELL_CHECKOUT_URL = 'https://checkout.maestrosindustriales.shop/cart/47957531263224:1';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/tuFoxUDEqhmxQX8maY7Rmk/Mercado_Libre.jpg', 'https://cdn.magicpatterns.com/uploads/pPJvXWY4bJL9dZW8mG2CW1/descarga.jpg', 'https://cdn.magicpatterns.com/uploads/1w3JTtAaPhJNXT5LstEj3s/Carro_de_arrastre.jpg', 'https://cdn.magicpatterns.com/uploads/9Hy3tgreCntYzcxpWPGre4/Estante_Vision_Light.jpg', 'https://cdn.magicpatterns.com/uploads/nBMzSC4jQoptTazs6eMxPf/Idea_for_elevated_shelf_coffee_bar.jpg', 'https://cdn.magicpatterns.com/uploads/79WBidoMhCcGVc2EV4vgM7/a2d8fd5e5a54797f1ead28787fc39cf9.jpg', 'https://cdn.magicpatterns.com/uploads/ijYXMTa5aQAoH4kWS84skC/descarga_(1).jpg', 'https://cdn.magicpatterns.com/uploads/isxqumkJKYCsuGMmceuzLF/d02ffcf8523b664ae13ecd3c80313403.jpg', 'https://cdn.magicpatterns.com/uploads/phyW8vHdEZv7yVwzueRKXE/Custom_Natural_Wood_Bookshelves.jpg'];
const EBOOK_PREVIEW_IMAGES = ['https://cdn.magicpatterns.com/uploads/w8C5g6BQpeT4rfYefSxVX2/capture_260131_162524.png', 'https://cdn.magicpatterns.com/uploads/sosZXNubdXe7um5YBtv71j/capture_260131_162625.png', 'https://cdn.magicpatterns.com/uploads/4TxwABQPhvZoSkUXR4NnZK/capture_260131_162636.png', 'https://cdn.magicpatterns.com/uploads/9NSEHn1wM1kuk4rJqZZ6DP/capture_260131_162930.png', 'https://cdn.magicpatterns.com/uploads/6xLj3uTRfgy2HuP6DX9qu1/capture_260131_163022.png'];
const BONUS_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/bsNuHGEFA4vXVMzB8Zb749/_hvsfq7UVS0ati8NEDewDqw_yRVWzHnITfOLECFjx49Q-g_2k.png',
  title: 'MÓDULO 1: Planos para Muebles Rentables',
  desc: 'Diseños listos para cortar y armar, pensados para productos de alta demanda.',
  price: '$10.700 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p2N8UbnH5SUvSsccZEgq4M/vpRUikLCRcKY6us7VndvfQ2k.webp',
  title: 'MÓDULO 2: Sistema de Presupuesto',
  desc: 'Calculadora para cobrar lo justo y ganar más en cada trabajo.',
  price: '$8.900 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i5QEvD9WY8kDHkpzozLjDt/_D3cFzWo8ST2Ggzz4TBGB4g_yBMj4frJQrOCy_cvImW-6g_2k.png',
  title: 'MÓDULO 3: Manual de Soldadura',
  desc: 'Técnicas fundamentales para lograr estructuras firmes y prolijas.',
  price: '$12.500 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/prJbjXeLzJJTwUZq9js8xs/_xR4h7ZpIQvmpw6Llrpwj3g_G8TJHEpaQc6UK_gxXcX2bQ_2k.png',
  title: 'MÓDULO 4: Formación Teórica',
  desc: 'La base del conocimiento industrial para evitar errores costosos.',
  price: '$9.800 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gDKgXCpfa8Z5k34F5H4JSS/ikvNh9P4SJ2OiUcz47WycA2k.webp',
  title: 'MÓDULO 5: Proyectos de Trailers y Portones',
  desc: '12 diseños listos para fabricar y vender, incluye planos completos de trailers y portones.',
  price: '$14.200 ARS'
}];
const CURATED_REVIEWS = [{
  name: 'Carlos M.',
  location: 'Buenos Aires',
  rating: 5,
  text: 'Yo laburo en herrería hace años y siempre improvisaba. Con los planos estos arranqué a trabajar más ordenado. Se nota la diferencia.'
}, {
  name: 'Luis R.',
  location: 'Córdoba',
  rating: 5,
  text: 'Pensé que era otro PDF más, pero la verdad están bien explicados y listos para usar. Ya hice dos trabajos sin renegar.'
}, {
  name: 'Martín G.',
  location: 'Rosario',
  rating: 4,
  text: 'Muy bueno, me ayudó a ordenar el laburo. Lo recomiendo.'
}, {
  name: 'Diego P.',
  location: 'Mendoza',
  rating: 5,
  text: 'Muy práctico. Para el que fabrica seguido, esto ahorra tiempo y errores.'
}, {
  name: 'Jorge S.',
  location: 'Santa Fe',
  rating: 5,
  text: 'Excelente material. Los planos de los trailers me sirvieron para agarrar un laburo grande.'
}, {
  name: 'Pablo D.',
  location: 'Tucumán',
  rating: 4,
  text: 'Buen material, lo estoy usando bastante. Cumple con lo que promete.'
}, {
  name: 'Fernando A.',
  location: 'Neuquén',
  rating: 5,
  text: 'Soy hobbista y me animé a hacer mi primera mesa. Quedó espectacular.'
}, {
  name: 'Ricardo V.',
  location: 'Mar del Plata',
  rating: 5,
  text: 'Buena info, directa al grano. Sin vueltas.'
}];
const RECENT_SALES = ['Martín de Buenos Aires', 'José de Ciudad de México', 'Andrés de Bogotá', 'Luis de Lima', 'Pablo de Santiago', 'Ricardo de Montevideo', 'Eduardo de Guadalajara'];
const FAQ_DATA = [{
  q: '¿Necesito experiencia previa para usar los planos?',
  a: 'No. Los planos están pensados tanto para quienes recién empiezan como para herreros con experiencia. Todo está explicado paso a paso, con medidas claras y criterio industrial.'
}, {
  q: '¿Qué tipo de proyectos voy a poder fabricar?',
  a: 'Muebles industriales, estructuras, portones, rejas, trailers y otros proyectos rentables. Son diseños probados y pensados para vender.'
}, {
  q: '¿En qué formato recibo el material?',
  a: 'Todo el contenido se entrega en formato digital (PDF y carpetas organizadas), listo para descargar y usar.'
}, {
  q: '¿El acceso es inmediato?',
  a: 'Sí. Apenas se confirma el pago, recibís el acceso automático al material completo.'
}, {
  q: '¿Puedo usar los planos para trabajar y vender?',
  a: 'Sí. Los planos están pensados para que fabriques y vendas tus propios proyectos sin improvisar.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 14 días de garantía. Si el material no es lo que esperabas, podés solicitar la devolución.'
}];
// --- Components ---
const MetaPixel = () => {
  useEffect(() => {
    // Remove any existing pixel scripts to prevent duplication
    const existingScripts = document.querySelectorAll('script[src*="fbevents.js"]');
    existingScripts.forEach(script => script.remove());
    // Remove existing fbq object if it exists
    if ((window as any).fbq) {
      delete (window as any).fbq;
      delete (window as any)._fbq;
    }
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1951517502462967');fbq('track','PageView');fbq('track', 'ViewContent', { content_name: 'Maestro de Muebles Industriales', content_category: 'Digital Product' });`;
    document.head.appendChild(script);
  }, []);
  return null;
};
const SocialProofPopup = () => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = RECENT_SALES[Math.floor(Math.random() * RECENT_SALES.length)];
      setText(`${randomName} acaba de comprar este libro`);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimer = setTimeout(showPopup, 10000);
    const loop = () => {
      const nextTime = Math.random() * 20000 + 20000;
      setTimeout(() => {
        showPopup();
        loop();
      }, nextTime);
    };
    const loopTimer = setTimeout(loop, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(loopTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-in-left" data-id="element-0">
      <div className="bg-neutral-900/95 backdrop-blur border border-yellow-500/20 text-white px-3 py-2 rounded-lg shadow-xl flex items-center gap-3 max-w-[280px]" data-id="element-1">
        <div className="bg-yellow-500/10 p-1.5 rounded-full" data-id="element-2">
          <ShieldCheck className="w-4 h-4 text-yellow-500" data-id="element-3" />
        </div>
        <div data-id="element-4">
          <p className="text-xs font-medium leading-tight" data-id="element-5">{text}</p>
          <p className="text-[10px] text-neutral-400 mt-0.5" data-id="element-6">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
};
const ScrollToBuy = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={handleClick} className={`cursor-pointer ${className}`} data-id="element-7">
      {children}
    </div>;
};
const WeldingMaskIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-8">
    <path d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9" />
    <path d="M7 8H17V13H7V8Z" fill="#EAB308" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-10" />
    <path d="M12 13V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-11" />
    <path d="M9 16H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-12" />
  </svg>;
const StickyHeader = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 transform ${visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'} bg-neutral-950/95 backdrop-blur-sm border-b border-neutral-800 py-2 shadow-lg`} data-id="element-13">
      <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-14">
        <div className="flex items-center gap-2" data-id="element-15">
          <img src={CODEX_LABS_LOGO} alt="Codex Labs" className="h-8 w-8 object-contain rounded" data-id="element-16" />
          <span className="font-bold text-white text-sm hidden sm:block" data-id="element-17">
            MAESTRO INDUSTRIAL
          </span>
        </div>
        <ScrollToBuy data-id="element-18">
          <button className="bg-yellow-500 hover:bg-yellow-400 text-black text-xs font-bold py-2 px-4 rounded transition-colors shadow-lg shadow-yellow-500/20" data-id="element-19">
            Acceder Ahora
          </button>
        </ScrollToBuy>
      </div>
    </div>;
};
const CTAButton = ({
  text,
  subtext,
  className = '',
  pulse = false
}: {
  text: string;
  subtext?: string;
  className?: string;
  pulse?: boolean;
}) => {
  return <ScrollToBuy className="w-full flex justify-center" data-id="element-20">
      <button className={`group relative overflow-hidden bg-yellow-400 hover:bg-yellow-300 text-neutral-900 font-black py-4 px-8 rounded-lg shadow-lg shadow-yellow-500/30 transition-all duration-300 w-full max-w-md text-center transform hover:scale-[1.02] ${pulse ? 'animate-glow-pulse' : ''} ${className}`} data-id="element-21">
        <span className="relative z-10 flex flex-col items-center justify-center gap-1" data-id="element-22">
          <span className="text-lg md:text-xl uppercase tracking-wide font-black" data-id="element-23">
            {text}
          </span>
          {subtext && <span className="text-xs font-normal opacity-90" data-id="element-24">{subtext}</span>}
        </span>
        <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-shine" data-id="element-25" />
      </button>
    </ScrollToBuy>;
};
// Trust Badge Component - IMPROVED: Bigger, more prominent, better hierarchy
const TrustBadge = () => {
  return <div className="max-w-4xl mx-auto mt-16 pt-8 border-t border-neutral-800 px-4" data-id="element-26">
      {/* Guarantee Title - More prominent */}
      <div className="flex items-center justify-center gap-3 mb-6" data-id="element-27">
        <ShieldCheck className="w-8 h-8 text-green-500" data-id="element-28" />
        <span className="text-2xl md:text-3xl font-bold text-white" data-id="element-29">
          Garantía de satisfacción
        </span>
      </div>

      {/* 14-day guarantee text */}
      <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-8 mb-8 max-w-2xl mx-auto text-center shadow-2xl" data-id="element-30">
        <p className="text-neutral-200 text-base md:text-lg leading-relaxed" data-id="element-31">
          Estamos tan seguros de que este Programa te va a encantar, que si no
          es así, te devolvemos el 100% de tu dinero.
        </p>
        <p className="text-neutral-200 text-base md:text-lg leading-relaxed mt-4" data-id="element-32">
          Tenés 14 días para probarlo sin riesgo.
        </p>
        <p className="text-neutral-200 text-base md:text-lg leading-relaxed mt-4" data-id="element-33">
          Si no te convence, nos escribís y te hacemos el reembolso.
        </p>
        <p className="text-yellow-500 font-bold text-lg md:text-xl mt-6" data-id="element-34">
          Así de simple.
        </p>
      </div>

      {/* Payment Methods - Mercado Pago only */}
      <div className="flex flex-col items-center gap-6" data-id="element-35">
        <img src={MERCADO_PAGO_IMG} alt="Mercado Pago - Medios de pago" className="h-20 md:h-24 object-contain" data-id="element-36" />

        {/* Trust Text - Larger and better contrast */}
        <div className="text-center space-y-2 max-w-sm" data-id="element-37">
          <p className="text-neutral-300 text-sm md:text-base font-medium" data-id="element-38">
            Compra 100% segura con protección de datos
          </p>
          <p className="text-neutral-300 text-sm md:text-base font-medium" data-id="element-39">
            Acceso instantáneo luego del pago
          </p>
          <p className="text-neutral-300 text-sm md:text-base font-medium" data-id="element-40">
            Producto digital profesional
          </p>
        </div>
      </div>
    </div>;
};
const ProjectsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % CAROUSEL_IMAGES.length);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + CAROUSEL_IMAGES.length) % CAROUSEL_IMAGES.length);
  }, []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 1800);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    setIsPaused(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextSlide();else prevSlide();
    }
    setTimeout(() => setIsPaused(false), 5000);
  };
  return <section className="space-y-8" data-id="element-41">
      <div className="text-center space-y-2" data-id="element-42">
        <h3 className="text-2xl md:text-3xl font-black uppercase text-white" data-id="element-43">
          Proyectos probados que podés fabricar con los planos
        </h3>
        <p className="text-neutral-400 font-medium text-sm md:text-base" data-id="element-44">
          Más de 600 diseños reales: muebles industriales, trailers, portones,
          máquinas de gym y más.
        </p>
      </div>

      <div className="relative overflow-hidden rounded-xl bg-neutral-900 border border-neutral-800 max-w-sm mx-auto" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-45">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-46">
          {CAROUSEL_IMAGES.map((img, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-47">
              <img src={img} alt={`Proyecto ${idx + 1}`} className="w-full aspect-[9/16] object-cover" data-id="element-48" />
            </div>)}
        </div>

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-49">
          {CAROUSEL_IMAGES.map((_, idx) => <button key={idx} onClick={() => {
          setCurrentIndex(idx);
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), 5000);
        }} className={`w-1.5 h-1.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-yellow-500' : 'bg-neutral-600'}`} data-id="element-50" />)}
        </div>
      </div>

      <p className="text-center text-neutral-500 text-sm" data-id="element-51">
        👉 Deslizá para ver proyectos reales fabricados con los planos
      </p>
    </section>;
};
const FearToSystemCard = () => {
  const {
    ref,
    isInView
  } = useInView();
  return <section ref={ref} className="bg-[#0b0b0b] border border-yellow-500/30 rounded-xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-52">
      {/* Subtle yellow accent line at top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-transparent via-yellow-500/60 to-transparent" data-id="element-53"></div>

      {/* Main Title - Refined hierarchy */}
      <h3 className={`text-2xl md:text-4xl font-black text-white leading-tight tracking-tight mb-6 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`} data-id="element-54">
        Trabajar sin planos no es libertad.
        <br data-id="element-55" />
        <span className="text-white" data-id="element-56">Es trabajar con miedo.</span>
      </h3>

      {/* Subtle separator */}
      <div className={`w-12 h-px bg-yellow-500/40 mx-auto mb-6 ${isInView ? 'animate-fade-in-up-delay-1' : 'opacity-0'}`} data-id="element-57"></div>

      <p className={`text-neutral-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8 ${isInView ? 'animate-fade-in-up-delay-2' : 'opacity-0'}`} data-id="element-58">
        Cuando todo lo pensás en la cabeza, medís de más, dudás y ajustás sobre
        la marcha. Avanzás… pero tenso.
      </p>

      <p className={`text-yellow-500 font-bold text-lg md:text-xl ${isInView ? 'animate-fade-in-up-delay-3' : 'opacity-0'}`} data-id="element-59">
        Los que venden todos los días trabajan con un sistema de planos claros.
      </p>
    </section>;
};
const ProblemsSection = () => {
  return <section className="space-y-8" style={{
    backgroundColor: '#0b0b0b'
  }} data-id="element-60">
      <div className="text-center space-y-2" data-id="element-61">
        <h3 className="text-3xl md:text-4xl font-black text-red-500 uppercase" data-id="element-62">
          LA REALIDAD DEL TALLER
        </h3>
        <p className="text-lg text-neutral-300" data-id="element-63">(QUE CASI NADIE DICE)</p>
        <p className="text-neutral-400 font-medium mt-4" data-id="element-64">
          Si esto te pasa, no es casualidad.
        </p>
      </div>

      <div className="bg-[#1a1a1a] border-l-4 border-red-500 rounded-lg p-6 md:p-8 space-y-6" data-id="element-65">
        <div className="space-y-6" data-id="element-66">
          <div className="flex gap-4" data-id="element-67">
            <div className="bg-neutral-800 w-10 h-10 rounded-full flex items-center justify-center shrink-0" data-id="element-68">
              <AlertTriangle className="text-red-500 w-5 h-5" data-id="element-69" />
            </div>
            <div data-id="element-70">
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-71">
                Empezás los proyectos "a ver qué sale"
              </h4>
              <p className="text-neutral-400 text-sm" data-id="element-72">
                Fabricás sin planos claros o, si estás por arrancar, dudás
                porque no sabés por dónde empezar. Todo lo tenés que pensar en
                tu cabeza mientras trabajás.
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-73">
            <div className="bg-neutral-800 w-10 h-10 rounded-full flex items-center justify-center shrink-0" data-id="element-74">
              <Wrench className="text-red-500 w-5 h-5" data-id="element-75" />
            </div>
            <div data-id="element-76">
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-77">
                Avanzás, pero con <span className="text-red-500" data-id="element-78">tensión</span>
              </h4>
              <p className="text-neutral-400 text-sm" data-id="element-79">
                Medís dos veces. Ajustás sobre la marcha. No estás tranquilo.
                Estás <span className="text-red-400" data-id="element-80">improvisando</span>.
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-81">
            <div className="bg-neutral-800 w-10 h-10 rounded-full flex items-center justify-center shrink-0" data-id="element-82">
              <Brain className="text-red-500 w-5 h-5" data-id="element-83" />
            </div>
            <div data-id="element-84">
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-85">
                El miedo que no se dice
              </h4>
              <p className="text-neutral-400 text-sm" data-id="element-86">
                No es miedo a equivocarte. Es miedo a que{' '}
                <span className="text-red-400" data-id="element-87">se note</span>: terminaciones
                flojas, estructuras inseguras, aspecto casero.
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-88">
            <div className="bg-neutral-800 w-10 h-10 rounded-full flex items-center justify-center shrink-0" data-id="element-89">
              <DollarSign className="text-red-500 w-5 h-5" data-id="element-90" />
            </div>
            <div data-id="element-91">
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-92">
                Y si todavía no arrancaste…
              </h4>
              <p className="text-neutral-400 text-sm" data-id="element-93">
                Miedo a invertir tiempo y materiales sin saber si va a funcionar
                o no.
              </p>
            </div>
          </div>
        </div>

        <p className="text-red-400 font-bold text-center pt-4 border-t border-neutral-700" data-id="element-94">
          Frustración, desgaste mental y trabajos que no te representan.
        </p>
      </div>

      <div className="bg-[#1a1a1a] border-l-4 border-yellow-500 rounded-lg p-6 md:p-8 space-y-4" data-id="element-95">
        <h4 className="text-xl font-black text-yellow-500 uppercase" data-id="element-96">
          El verdadero bloqueo no es la habilidad
        </h4>
        <p className="text-lg text-white font-medium" data-id="element-97">
          Es trabajar sin un sistema.
        </p>

        <p className="text-neutral-300 pt-2" data-id="element-98">
          Los que venden todos los días{' '}
          <span className="text-yellow-500 font-bold" data-id="element-99">no improvisan</span>.
          Trabajan con:
        </p>

        <ul className="space-y-2 pt-2" data-id="element-100">
          {['Planos claros', 'Medidas exactas', 'Estructuras que funcionan'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-101">
              <Check className="w-5 h-5 text-yellow-500 shrink-0" data-id="element-102" />
              <span className="text-yellow-400 font-medium" data-id="element-103">{item}</span>
            </li>)}
        </ul>

        <p className="text-neutral-400 text-sm pt-2" data-id="element-104">
          Y un criterio pensado para fabricar y vender, no para adivinar.
        </p>
      </div>

      {/* Clean Comparison with Icons (no boxes, no animations) */}
      <div className="space-y-6 pt-8" data-id="element-105">
        <div className="flex items-start gap-4" data-id="element-106">
          <X className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-107" />
          <div data-id="element-108">
            <p className="text-white font-bold mb-1" data-id="element-109">Los que improvisan</p>
            <p className="text-neutral-400 text-sm" data-id="element-110">
              Trabajan con{' '}
              <span className="text-red-400 font-medium" data-id="element-111">duda</span>,{' '}
              <span className="text-red-400 font-medium" data-id="element-112">tensión</span> y{' '}
              <span className="text-red-400 font-medium" data-id="element-113">miedo</span> a
              equivocarse.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4" data-id="element-114">
          <Check className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-115" />
          <div data-id="element-116">
            <p className="text-white font-bold mb-1" data-id="element-117">
              Los que trabajan con sistema
            </p>
            <p className="text-neutral-400 text-sm" data-id="element-118">
              Ejecutan con{' '}
              <span className="text-green-400 font-medium" data-id="element-119">seguridad</span>,
              avanzan <span className="text-green-400 font-medium" data-id="element-120">rápido</span>{' '}
              y cobran con{' '}
              <span className="text-green-400 font-medium" data-id="element-121">confianza</span>.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
const BenefitsAndForYouSection = () => {
  return <section className="space-y-16" data-id="element-122">
      <div className="space-y-6" data-id="element-123">
        <div className="text-center space-y-2" data-id="element-124">
          <h3 className="text-2xl md:text-3xl font-black text-white uppercase" data-id="element-125">
            LO QUE CAMBIA CUANDO DEJÁS DE IMPROVISAR
          </h3>
          <p className="text-neutral-400" data-id="element-126">
            Cuando trabajás con planos claros, el taller se siente distinto.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-127">
          {['Trabajás con tranquilidad, sin estar adivinando', 'Ejecutás cada paso sin dudar', 'Te equivocás menos y desperdiciás menos material', 'Terminás los trabajos más rápido', 'Cobrás con confianza profesional'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-128">
              <Check className="text-green-500 w-5 h-5 mt-0.5 shrink-0" data-id="element-129" />
              <span className="text-neutral-200" data-id="element-130">{item}</span>
            </div>)}
        </div>
      </div>

      <div className="bg-neutral-900 border border-yellow-500/30 p-8 md:p-10 rounded-xl" data-id="element-131">
        <h3 className="text-2xl md:text-3xl font-black mb-8 text-center text-white uppercase" data-id="element-132">
          ESTE EBOOK ES PARA VOS SI…
        </h3>
        <div className="space-y-4 max-w-2xl mx-auto" data-id="element-133">
          {[{
          text: 'Querés dejar de improvisar y trabajar con un ',
          highlight: 'sistema claro, paso a paso'
        }, {
          text: 'Buscás fabricar muebles industriales que ',
          highlight: 'se vendan',
          suffix: ', no solo "que salgan"'
        }, {
          text: 'Querés ahorrar ',
          highlight: 'tiempo, materiales y frustración'
        }, {
          text: 'Necesitás modelos repetibles para ',
          highlight: 'crecer como taller'
        }, {
          text: 'Querés sentirte profesional y ',
          highlight: 'cobrar lo que corresponde'
        }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-134">
              <div className="bg-green-500/10 p-1 rounded-full shrink-0 mt-0.5" data-id="element-135">
                <Check className="text-green-500 w-4 h-4" data-id="element-136" />
              </div>
              <span className="text-neutral-200" data-id="element-137">
                {item.text}
                <span className="text-yellow-500 font-bold" data-id="element-138">
                  {item.highlight}
                </span>
                {item.suffix || ''}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};
const BonusesSection = () => {
  return <section className="space-y-12" data-id="element-139">
      <div className="text-center space-y-2" data-id="element-140">
        <span className="inline-block bg-neutral-800 border border-yellow-500/50 text-yellow-500 text-xs font-bold uppercase px-4 py-1 rounded-full" data-id="element-141">
          ACCESO ESPECIAL DISPONIBLE HOY
        </span>
        <h3 className="text-3xl md:text-4xl font-black text-yellow-500 uppercase" data-id="element-142">
          ACCESO COMPLETO + BONOS INCLUIDOS
        </h3>
        <p className="text-neutral-400 font-medium" data-id="element-143">
          Todo lo que recibís con tu acceso
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-144">
        {BONUS_IMAGES.map((bonus, idx) => <ScrollToBuy key={idx} className="group bg-neutral-900 rounded-xl overflow-hidden border border-yellow-500 hover:scale-[1.02] transition-all duration-300 shadow-lg shadow-yellow-500/5" data-id="element-145">
            <div className="aspect-square w-full max-w-[400px] mx-auto overflow-hidden bg-black p-4" data-id="element-146">
              <img src={bonus.src} alt={bonus.title} className="w-full h-full object-contain" data-id="element-147" />
            </div>
            <div className="p-6 space-y-4 bg-neutral-800/50 border-t border-neutral-800" data-id="element-148">
              <div data-id="element-149">
                <h4 className="text-lg font-black text-white mb-2 uppercase" data-id="element-150">
                  {bonus.title}
                </h4>
                <p className="text-neutral-400 text-sm" data-id="element-151">{bonus.desc}</p>
              </div>
              <div className="flex items-center justify-between pt-3 border-t border-neutral-700" data-id="element-152">
                <span className="text-neutral-500 line-through text-sm font-bold" data-id="element-153">
                  {bonus.price}
                </span>
                <div className="flex items-center gap-1.5 bg-green-500/10 px-3 py-1 rounded border border-green-500/20" data-id="element-154">
                  <Check className="w-3 h-3 text-green-500" data-id="element-155" />
                  <span className="text-green-500 text-xs font-black uppercase" data-id="element-156">
                    INCLUIDO
                  </span>
                </div>
              </div>
            </div>
          </ScrollToBuy>)}
      </div>
    </section>;
};
const CompactAccessSection = () => {
  return <section className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 md:p-8" data-id="element-157">
      <div className="text-center mb-6" data-id="element-158">
        <span className="inline-block bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs font-bold uppercase px-3 py-1 rounded-full mb-3" data-id="element-159">
          ACCESO COMPLETO DISPONIBLE HOY
        </span>
        <h3 className="text-xl md:text-2xl font-black text-white uppercase" data-id="element-160">
          MAESTRO DE MUEBLES INDUSTRIALES 2026 +{' '}
          <span className="text-yellow-500" data-id="element-161">BONOS</span>
        </h3>
      </div>

      {/* NEW: Hero bundle image */}
      <div className="mb-8" data-id="element-162">
        <img src={BUNDLE_HERO_IMG} alt="Maestro de Muebles Industriales - Pack Completo con Bonos" className="w-[90%] mx-auto rounded-lg" data-id="element-163" />
      </div>

      <p className="text-neutral-400 text-sm mt-2 max-w-lg mx-auto text-center mb-6" data-id="element-164">
        Accedés al sistema completo de planos industriales para fabricar con
        método, cobrar como profesional y dejar de improvisar.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto" data-id="element-165">
        {['Ebook Maestro de Muebles Industriales', '+600 planos industriales listos para fabricar', 'Sistema de presupuesto y cierre', 'Manual de soldadura + formación teórica', 'Proyectos especiales: trailers y portones', 'Bonos extra incluidos hoy'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-166">
            <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-167" />
            <span className="text-neutral-300 text-sm" data-id="element-168">{item}</span>
          </div>)}
      </div>
    </section>;
};
// Dynamic Purchase Card with aggressive urgency animations
const DynamicPurchaseCard = () => {
  const [viewers, setViewers] = useState(47);
  const [displayViewers, setDisplayViewers] = useState(47);
  const [spots, setSpots] = useState(5);
  const [currentDate, setCurrentDate] = useState('');
  const [viewerFade, setViewerFade] = useState(false);
  const viewerIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const spotsIntervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    };
    setCurrentDate(date.toLocaleDateString('es-ES', options));
    const storedSpots = localStorage.getItem('promo_spots');
    const storedTime = localStorage.getItem('promo_time');
    const now = Date.now();
    if (storedSpots && storedTime) {
      const elapsed = now - parseInt(storedTime);
      if (elapsed > 86400000) {
        const newSpots = 7 + Math.floor(Math.random() * 6);
        setSpots(newSpots);
        localStorage.setItem('promo_spots', String(newSpots));
        localStorage.setItem('promo_time', String(now));
      } else {
        setSpots(parseInt(storedSpots));
      }
    } else {
      const newSpots = 7 + Math.floor(Math.random() * 6);
      setSpots(newSpots);
      localStorage.setItem('promo_spots', String(newSpots));
      localStorage.setItem('promo_time', String(now));
    }
    const initialViewers = 18 + Math.floor(Math.random() * 70);
    setViewers(initialViewers);
    setDisplayViewers(initialViewers);
    const updateViewers = () => {
      setViewerFade(true);
      setTimeout(() => {
        setViewers(prev => {
          const changes = [5, -3, 8, -6, 12, -4, 7, -9, 15, -7, 10, -5, 6, -8, 11, -10, 14, -12];
          const change = changes[Math.floor(Math.random() * changes.length)];
          let next = prev + change;
          if (next < 18) next = 18 + Math.floor(Math.random() * 15);
          if (next > 87) next = 87 - Math.floor(Math.random() * 15);
          setDisplayViewers(next);
          return next;
        });
        setViewerFade(false);
      }, 150);
      const nextInterval = 6000 + Math.random() * 4000;
      viewerIntervalRef.current = setTimeout(updateViewers, nextInterval);
    };
    viewerIntervalRef.current = setTimeout(updateViewers, 6000 + Math.random() * 4000);
    const updateSpots = () => {
      setSpots(prev => {
        if (prev > 2 && Math.random() > 0.3) {
          const newVal = prev - 1;
          localStorage.setItem('promo_spots', String(newVal));
          return newVal;
        }
        return prev;
      });
      const nextInterval = 45000 + Math.random() * 75000;
      spotsIntervalRef.current = setTimeout(updateSpots, nextInterval);
    };
    spotsIntervalRef.current = setTimeout(updateSpots, 45000 + Math.random() * 75000);
    return () => {
      if (viewerIntervalRef.current) clearTimeout(viewerIntervalRef.current);
      if (spotsIntervalRef.current) clearTimeout(spotsIntervalRef.current);
    };
  }, []);
  const handleMainCheckout = () => {
    // Track AddToCart
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Maestro de Muebles Industriales',
        content_category: 'Ebook',
        value: 19990.0,
        currency: 'ARS'
      });
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Maestro de Muebles Industriales',
        value: 19990.0,
        currency: 'ARS'
      });
    }
    window.location.href = MAIN_CHECKOUT_URL;
  };
  const isLowSpots = spots <= 5;
  return <div id="compra" className="w-full max-w-2xl mx-auto bg-neutral-900 rounded-xl border border-neutral-800 shadow-2xl overflow-hidden" data-id="element-169">
      <div className="bg-neutral-800 py-3 px-4 text-center border-b border-yellow-500/30 flex flex-col sm:flex-row justify-center items-center gap-2" data-id="element-170">
        <p className="text-yellow-400 font-bold text-sm uppercase tracking-wide" data-id="element-171">
          Oferta válida solo por hoy:
        </p>
        <p className="text-white font-bold text-sm" data-id="element-172">{currentDate}</p>
      </div>

      <div className="p-6 md:p-8 space-y-6" data-id="element-173">
        <div className="flex flex-col sm:flex-row gap-4 justify-between text-sm" data-id="element-174">
          <div className="flex items-center gap-2 text-neutral-300" data-id="element-175">
            <span className="relative flex h-3 w-3" data-id="element-176">
              <span className="animate-urgency-green absolute inline-flex h-full w-full rounded-full bg-green-400" data-id="element-177"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-178"></span>
            </span>
            <span className={`font-medium transition-opacity duration-150 ${viewerFade ? 'opacity-50' : 'opacity-100'}`} data-id="element-179">
              {displayViewers} personas viendo esta página
            </span>
          </div>
          <div className={`flex items-center gap-2 text-neutral-300 ${isLowSpots ? 'animate-subtle-shake' : ''}`} data-id="element-180">
            <span className="relative flex h-3 w-3" data-id="element-181">
              <span className={`absolute inline-flex h-full w-full rounded-full bg-red-400 ${isLowSpots ? 'animate-urgency-red-fast' : 'animate-urgency-red'}`} data-id="element-182"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-183"></span>
            </span>
            <span className="font-medium text-red-400" data-id="element-184">
              Quedan {spots} cupos promocionales
            </span>
          </div>
        </div>

        <div className="bg-neutral-950 rounded-xl p-6 border border-neutral-800 text-center relative overflow-hidden" data-id="element-185">
          <div className="absolute top-0 right-0 bg-neutral-700 text-yellow-400 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-186">
            DESCUENTO ESPECIAL
          </div>

          <div className="space-y-1 mb-6" data-id="element-187">
            <p className="text-neutral-500 text-lg line-through decoration-neutral-500 decoration-2 font-bold" data-id="element-188">
              $49.900 ARS
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-189">
              <span className="text-5xl md:text-6xl font-black text-white tracking-tight" data-id="element-190">
                $19.990
              </span>
              <span className="text-xl font-medium text-neutral-400 mt-4" data-id="element-191">
                ARS
              </span>
            </div>
          </div>

          <div className="inline-flex items-center gap-2 bg-neutral-900 px-4 py-2 rounded-full border border-neutral-800 mb-6" data-id="element-192">
            <CreditCard className="w-4 h-4 text-green-500" data-id="element-193" />
            <span className="text-sm font-medium text-neutral-300" data-id="element-194">
              Hasta 3 cuotas sin interés
            </span>
          </div>

          {/* Main CTA Button - Redirects to checkout */}
          <button onClick={handleMainCheckout} className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-black text-lg py-4 rounded-xl btn-premium" data-id="element-195">
            QUIERO ACCEDER AL SISTEMA COMPLETO
          </button>

          {/* Updated Benefits List */}
          <div className="mt-6 space-y-3 text-sm text-neutral-300 text-left max-w-sm mx-auto" data-id="element-196">
            {['Acceso inmediato y de por vida', 'Descarga 100% segura', 'Actualizaciones incluidas', 'Garantía de satisfacción de 14 días', 'Soporte por mail ante cualquier inconveniente'].map((benefit, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-197">
                <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-198" />
                <span data-id="element-199">{benefit}</span>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-2 border-t border-neutral-800 pt-6" data-id="element-200">
          <div className="flex items-center justify-center gap-2 text-green-500 font-medium" data-id="element-201">
            <ShieldCheck className="w-5 h-5" data-id="element-202" />
            <span data-id="element-203">Garantía de satisfacción</span>
          </div>
        </div>
      </div>
    </div>;
};
const UpsellSection = () => {
  const handleSkipUpsell = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleUpsellCheckout = () => {
    // Track AddToCart for Upsell
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Pack Completo + Máquinas',
        content_category: 'Bundle',
        value: 26990.0,
        currency: 'ARS'
      });
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Pack Completo + Máquinas',
        value: 26990.0,
        currency: 'ARS'
      });
    }
    window.location.href = UPSELL_CHECKOUT_URL;
  };
  return <div className="max-w-3xl mx-auto mt-16" data-id="element-204">
      <div className="bg-neutral-900 border border-yellow-500/30 rounded-xl overflow-hidden shadow-2xl" data-id="element-205">
        <div className="bg-neutral-800 p-4 text-center border-b border-yellow-500/20" data-id="element-206">
          <h3 className="text-xl md:text-2xl font-black text-yellow-500 uppercase" data-id="element-207">
            Sumá esta colección exclusiva
          </h3>
        </div>

        <div className="p-6 md:p-8 grid md:grid-cols-2 gap-8 items-center" data-id="element-208">
          <div className="relative group" data-id="element-209">
            <img src={UPSELL_IMG} alt="Maquinas de Gimnasio" className="relative z-10 w-full rounded shadow-xl transform group-hover:scale-105 transition-transform duration-300 border border-neutral-800" data-id="element-210" />
          </div>

          <div className="space-y-6" data-id="element-211">
            <div data-id="element-212">
              <h4 className="text-xl font-bold text-white mb-2 uppercase" data-id="element-213">
                +100 MÁQUINAS DE GIMNASIO
              </h4>
              <p className="text-neutral-400 text-sm font-medium uppercase tracking-wider" data-id="element-214">
                EDICIÓN INDUSTRIAL
              </p>
            </div>

            <ul className="space-y-3" data-id="element-215">
              {['Más de 100 máquinas de gimnasio', 'Diseños industriales probados', 'Ideal para ampliar tu negocio', 'Complemento perfecto para herreros'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-300" data-id="element-216">
                  <Check className="w-4 h-4 text-green-500 mt-0.5 shrink-0" data-id="element-217" />
                  {item}
                </li>)}
            </ul>

            <div className="space-y-4" data-id="element-218">
              <button onClick={handleSkipUpsell} className="w-full text-neutral-500 hover:text-neutral-300 text-xs md:text-sm font-medium transition-colors text-center block cursor-pointer" data-id="element-219">
                No, continuar sin este extra
              </button>

              <div className="flex flex-col justify-center md:justify-start" data-id="element-220">
                <span className="text-yellow-500 text-xs font-bold uppercase mb-1" data-id="element-221">
                  Precio especial por única vez
                </span>
                <div className="flex items-baseline gap-3" data-id="element-222">
                  <span className="text-neutral-500 line-through text-sm font-bold" data-id="element-223">
                    $69.990
                  </span>
                  <span className="text-4xl font-black text-white" data-id="element-224">
                    $26.990
                  </span>
                </div>
              </div>

              {/* Installment info - Upsell only */}
              <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-225">
                <CreditCard className="w-4 h-4 text-green-500" data-id="element-226" />
                <span className="text-sm font-medium text-neutral-300" data-id="element-227">
                  Hasta 3 cuotas sin interés con Mercado Pago
                </span>
              </div>

              {/* Upsell CTA Button - Enhanced */}
              <button onClick={handleUpsellCheckout} className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-black py-4 rounded-xl transition-all duration-200 text-sm md:text-base uppercase tracking-[0.2em] shadow-lg hover:shadow-yellow-500/40 hover:scale-[1.02] animate-btn-glow" data-id="element-228">
                Sumar este pack a mi acceso
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
// Reviews Section with 1-5 star rating
const ReviewsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [newReview, setNewReview] = useState({
    name: '',
    text: '',
    rating: 5
  });
  const [hoverRating, setHoverRating] = useState(0);
  const [userReview, setUserReview] = useState<{
    name: string;
    text: string;
    rating: number;
  } | null>(null);
  const [toast, setToast] = useState(false);
  const visibleReviews = showAll ? CURATED_REVIEWS : CURATED_REVIEWS.slice(0, 3);
  const remainingCount = CURATED_REVIEWS.length - 3;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newReview.name.trim() || !newReview.text.trim()) return;
    setUserReview({
      ...newReview
    });
    setNewReview({
      name: '',
      text: '',
      rating: 5
    });
    setShowForm(false);
    setToast(true);
    setTimeout(() => setToast(false), 3000);
  };
  return <section className="py-16 bg-neutral-900 text-white border-t border-neutral-800 relative" data-id="element-229">
      {toast && <div className="fixed top-24 left-1/2 -translate-x-1/2 bg-neutral-800 border border-green-500/50 text-white px-6 py-4 rounded-lg shadow-2xl z-50 flex items-center gap-3" data-id="element-230">
          <div className="bg-green-500/20 p-1 rounded-full" data-id="element-231">
            <Check className="w-5 h-5 text-green-500" data-id="element-232" />
          </div>
          <p className="font-medium text-sm" data-id="element-233">Gracias por tu comentario</p>
        </div>}

      <div className="max-w-4xl mx-auto px-4" data-id="element-234">
        <div className="text-center mb-12 space-y-4" data-id="element-235">
          <h3 className="text-3xl font-black text-white uppercase" data-id="element-236">
            Lo que dicen quienes ya fabrican con método
          </h3>
          <div className="flex flex-col items-center gap-2" data-id="element-237">
            <p className="text-xl font-medium text-yellow-500" data-id="element-238">
              Más de 3.000 herreros satisfechos
            </p>
            <div className="flex gap-1" data-id="element-239">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-240" />)}
            </div>
            <p className="text-sm text-neutral-400" data-id="element-241">
              4,9/5 · reseñas verificadas
            </p>
          </div>
        </div>

        <div className="space-y-4 mb-8" data-id="element-242">
          {userReview && <div className="bg-neutral-800 p-6 rounded border border-yellow-500/30" data-id="element-243">
              <div className="flex gap-1 mb-3" data-id="element-244">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < userReview.rating ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-245" />)}
              </div>
              <p className="text-neutral-300 mb-4 italic" data-id="element-246">
                "{userReview.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-247">
                <div className="w-8 h-8 bg-yellow-500/20 rounded-full flex items-center justify-center text-yellow-500 font-bold text-xs border border-yellow-500/30" data-id="element-248">
                  {userReview.name.charAt(0)}
                </div>
                <div data-id="element-249">
                  <p className="font-bold text-sm text-white" data-id="element-250">
                    {userReview.name}
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-251">Tu reseña</p>
                </div>
              </div>
            </div>}

          {visibleReviews.map((review, i) => <div key={i} className="bg-neutral-800 p-6 rounded border border-neutral-700" data-id="element-252">
              <div className="flex gap-1 mb-3" data-id="element-253">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < review.rating ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-254" />)}
              </div>
              <p className="text-neutral-300 mb-4 italic" data-id="element-255">"{review.text}"</p>
              <div className="flex items-center gap-3" data-id="element-256">
                <div className="w-8 h-8 bg-neutral-700 rounded-full flex items-center justify-center text-yellow-500 font-bold text-xs border border-neutral-600" data-id="element-257">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-258">
                  <p className="font-bold text-sm text-white" data-id="element-259">{review.name}</p>
                  <p className="text-xs text-neutral-500" data-id="element-260">{review.location}</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-261">
          {!showAll && remainingCount > 0 && <button onClick={() => setShowAll(true)} className="text-neutral-400 hover:text-white text-sm font-medium transition-colors" data-id="element-262">
              Ver {remainingCount} comentarios más
            </button>}

          {!userReview && <button onClick={() => setShowForm(!showForm)} className="bg-neutral-800 hover:bg-neutral-700 text-white px-6 py-3 rounded border border-neutral-700 font-medium transition-colors flex items-center gap-2" data-id="element-263">
              <MessageSquare className="w-4 h-4" data-id="element-264" />
              Dejar mi reseña
            </button>}

          {showForm && <div className="bg-neutral-800 p-6 rounded border border-neutral-700 max-w-xl w-full" data-id="element-265">
              <h4 className="font-bold text-lg mb-4 text-center text-yellow-500" data-id="element-266">
                Tu opinión nos importa
              </h4>
              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-267">
                <input type="text" placeholder="Tu nombre" className="w-full p-3 rounded bg-neutral-900 border border-neutral-700 text-white focus:border-yellow-500 outline-none" value={newReview.name} onChange={e => setNewReview({
              ...newReview,
              name: e.target.value
            })} data-id="element-268" />
                <textarea placeholder="Tu experiencia con los planos..." rows={3} className="w-full p-3 rounded bg-neutral-900 border border-neutral-700 text-white focus:border-yellow-500 outline-none resize-none" value={newReview.text} onChange={e => setNewReview({
              ...newReview,
              text: e.target.value
            })} data-id="element-269" />
                <div className="flex items-center gap-3" data-id="element-270">
                  <span className="text-sm text-neutral-400" data-id="element-271">
                    Calificación:
                  </span>
                  <div className="flex gap-1" data-id="element-272">
                    {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setNewReview({
                  ...newReview,
                  rating: star
                })} className="p-1 transition-transform hover:scale-110" data-id="element-273">
                        <Star className={`w-6 h-6 transition-colors ${(hoverRating ? star <= hoverRating : star <= newReview.rating) ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-274" />
                      </button>)}
                  </div>
                </div>
                <button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 rounded transition-colors" data-id="element-275">
                  Enviar reseña
                </button>
              </form>
            </div>}
        </div>
      </div>
    </section>;
};
const TrustSection = () => {
  return <section className="bg-[#1a1a1a] border border-yellow-500/20 rounded-xl p-8 md:p-10" data-id="element-276">
      <div className="text-center mb-8" data-id="element-277">
        <h3 className="text-xl md:text-2xl font-black text-white flex items-center justify-center gap-2" data-id="element-278">
          <Lock className="w-5 h-5 text-yellow-500" data-id="element-279" />
          Compra segura y acceso inmediato
        </h3>
        <p className="text-neutral-400 text-sm mt-2" data-id="element-280">
          Este material fue creado para que trabajes con tranquilidad, claridad
          y respaldo desde el primer día.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-281">
        <div className="flex items-start gap-3 p-4 bg-neutral-900/50 rounded-lg" data-id="element-282">
          <Zap className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-283" />
          <div data-id="element-284">
            <p className="text-white font-bold text-sm" data-id="element-285">Acceso inmediato</p>
            <p className="text-neutral-400 text-xs" data-id="element-286">
              Recibís el material completo apenas se confirma el pago.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 p-4 bg-neutral-900/50 rounded-lg" data-id="element-287">
          <Download className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-288" />
          <div data-id="element-289">
            <p className="text-white font-bold text-sm" data-id="element-290">
              Descarga segura y privada
            </p>
            <p className="text-neutral-400 text-xs" data-id="element-291">
              Tus archivos están protegidos y disponibles para siempre.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 p-4 bg-neutral-900/50 rounded-lg" data-id="element-292">
          <ShieldCheck className="w-5 h-5 text-yellow-500 shrink-0 mt-0.5" data-id="element-293" />
          <div data-id="element-294">
            <p className="text-white font-bold text-sm" data-id="element-295">
              Garantía de satisfacción 14 días
            </p>
            <p className="text-neutral-400 text-xs" data-id="element-296">
              Si no es lo que esperabas, podés solicitar la devolución.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 p-4 bg-neutral-900/50 rounded-lg" data-id="element-297">
          <BookOpen className="w-5 h-5 text-yellow-500 shrink-0 mt-0.5" data-id="element-298" />
          <div data-id="element-299">
            <p className="text-white font-bold text-sm" data-id="element-300">
              Producto digital profesional
            </p>
            <p className="text-neutral-400 text-xs" data-id="element-301">
              Planos claros, medidas exactas y criterio industrial real.
            </p>
          </div>
        </div>
      </div>

      <p className="text-center text-neutral-500 text-sm mt-6" data-id="element-302">
        Más de 3.200 herreros y fabricantes ya trabajan con este sistema.
      </p>
    </section>;
};
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="space-y-8" data-id="element-303">
      <div className="text-center space-y-2" data-id="element-304">
        <h3 className="text-2xl md:text-3xl font-black text-white" data-id="element-305">
          Resolvé acá tus dudas antes de comprar
        </h3>
        <p className="text-neutral-400" data-id="element-306">
          Todo lo que necesitás saber sobre el acceso y el contenido
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-3" data-id="element-307">
        {FAQ_DATA.map((faq, i) => <div key={i} className="bg-[#1a1a1a] border border-neutral-700/50 rounded-lg overflow-hidden" data-id="element-308">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full p-5 flex items-center justify-between text-left" data-id="element-309">
              <div className="flex items-center gap-3" data-id="element-310">
                <HelpCircle className="w-5 h-5 text-yellow-500 shrink-0" data-id="element-311" />
                <span className="text-white font-medium" data-id="element-312">{faq.q}</span>
              </div>
              <ChevronDown className={`w-5 h-5 text-neutral-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-313" />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-40' : 'max-h-0'}`} data-id="element-314">
              <p className="px-5 pb-5 text-neutral-400 text-sm pl-13" data-id="element-315">
                {faq.a}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
};
const FabricarSection = () => {
  return <section className="space-y-8" data-id="element-316">
      <div className="text-center space-y-2" data-id="element-317">
        <h3 className="text-3xl font-black text-white uppercase" data-id="element-318">
          Mirá todo lo que vas a poder{' '}
          <span className="text-yellow-500" data-id="element-319">FABRICAR</span>
        </h3>
        <p className="text-neutral-400 font-medium" data-id="element-320">
          Cada diseño está probado por herreros reales en Argentina
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-321">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full" data-id="element-322">
          <div className="flex items-center gap-3 mb-4" data-id="element-323">
            <Hammer className="text-yellow-500 w-5 h-5" data-id="element-324" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-325">
              Muebles de Acero y Madera
            </h4>
          </div>
          <ul className="space-y-3 mb-6 flex-1" data-id="element-326">
            {['Alta demanda real', 'Se venden todo el año', 'Precios 3-4x más altos'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-400" data-id="element-327">
                <Check className="w-4 h-4 text-yellow-500 mt-0.5 shrink-0" data-id="element-328" />
                {item}
              </li>)}
          </ul>
          <div className="bg-rose-900/30 text-rose-400 text-xs font-bold uppercase py-1.5 px-3 rounded-full text-center w-fit mx-auto" data-id="element-329">
            EL MÁS PEDIDO
          </div>
        </div>

        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full" data-id="element-330">
          <div className="flex items-center gap-3 mb-4" data-id="element-331">
            <Wrench className="text-yellow-500 w-5 h-5" data-id="element-332" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-333">
              Estructuras Industriales
            </h4>
          </div>
          <ul className="space-y-3 mb-6 flex-1" data-id="element-334">
            {['Proyectos de mayor escala', 'Clientes recurrentes', 'Margen alto por proyecto'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-400" data-id="element-335">
                <Check className="w-4 h-4 text-yellow-500 mt-0.5 shrink-0" data-id="element-336" />
                {item}
              </li>)}
          </ul>
          <div className="bg-yellow-900/30 text-yellow-400 text-xs font-bold uppercase py-1.5 px-3 rounded-full text-center w-fit mx-auto" data-id="element-337">
            ALTA RENTABILIDAD
          </div>
        </div>

        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full" data-id="element-338">
          <div className="flex items-center gap-3 mb-4" data-id="element-339">
            <Layout className="text-yellow-500 w-5 h-5" data-id="element-340" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-341">
              Portones, Rejas y Cerramientos
            </h4>
          </div>
          <ul className="space-y-3 mb-6 flex-1" data-id="element-342">
            {['Demanda constante', 'Trabajo estable', 'Buen ticket promedio'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-400" data-id="element-343">
                <Check className="w-4 h-4 text-yellow-500 mt-0.5 shrink-0" data-id="element-344" />
                {item}
              </li>)}
          </ul>
          <div className="bg-green-900/30 text-green-400 text-xs font-bold uppercase py-1.5 px-3 rounded-full text-center w-fit mx-auto" data-id="element-345">
            NEGOCIO ESTABLE
          </div>
        </div>
      </div>
    </section>;
};
const EbookPreviewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % EBOOK_PREVIEW_IMAGES.length);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + EBOOK_PREVIEW_IMAGES.length) % EBOOK_PREVIEW_IMAGES.length);
  }, []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    setIsPaused(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextSlide();else prevSlide();
    }
    setTimeout(() => setIsPaused(false), 5000);
  };
  return <section className="space-y-8" data-id="element-346">
      <div className="text-center space-y-2" data-id="element-347">
        <h3 className="text-2xl md:text-3xl font-black text-white" data-id="element-348">
          Así se ve por dentro el ebook
        </h3>
        <p className="text-neutral-400 text-sm md:text-base" data-id="element-349">
          Ejemplos reales de páginas, planos y guías incluidas en Maestro de
          Muebles Industriales
        </p>
      </div>

      <div className="relative overflow-hidden rounded-xl bg-neutral-900 border border-neutral-800 max-w-md mx-auto shadow-2xl" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-350">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-351">
          {EBOOK_PREVIEW_IMAGES.map((img, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-352">
              <img src={img} alt={`Página del ebook ${idx + 1}`} className="w-full aspect-[9/16] object-contain bg-white" data-id="element-353" />
            </div>)}
        </div>

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-354">
          {EBOOK_PREVIEW_IMAGES.map((_, idx) => <button key={idx} onClick={() => {
          setCurrentIndex(idx);
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), 5000);
        }} className={`w-2 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-yellow-500' : 'bg-neutral-600'}`} data-id="element-355" />)}
        </div>
      </div>

      <p className="text-center text-neutral-400 text-sm" data-id="element-356">
        <span className="text-yellow-500 font-medium" data-id="element-357">Planos claros</span>,{' '}
        <span className="text-yellow-500 font-medium" data-id="element-358">medidas exactas</span> y{' '}
        <span className="text-yellow-500 font-medium" data-id="element-359">criterio industrial</span>{' '}
        aplicado a cada proyecto.
      </p>
    </section>;
};
// Custom hook for scroll-triggered animations
const useInView = (options = {}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.unobserve(element);
      }
    }, {
      threshold: 0.1,
      ...options
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return {
    ref,
    isInView
  };
};
export function App() {
  return <div className="min-h-screen bg-neutral-950 text-neutral-200 font-sans selection:bg-yellow-500/30 selection:text-yellow-200" data-id="element-360">
      <style data-id="element-361">{`
        @keyframes glow-pulse {
          0%, 100% { box-shadow: 0 0 20px rgba(234, 179, 8, 0.3); }
          50% { box-shadow: 0 0 30px rgba(234, 179, 8, 0.5); }
        }
        .animate-glow-pulse { animation: glow-pulse 3s infinite; }
        
        @keyframes btn-glow {
          0%, 100% { box-shadow: 0 4px 20px rgba(234, 179, 8, 0.3); }
          50% { box-shadow: 0 4px 35px rgba(234, 179, 8, 0.5); }
        }
        .animate-btn-glow { animation: btn-glow 2.5s ease-in-out infinite; }
        
        @keyframes urgency-green {
          0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
          50% { transform: scale(1.3); opacity: 0.5; box-shadow: 0 0 8px 4px rgba(34, 197, 94, 0.4); }
        }
        .animate-urgency-green { animation: urgency-green 1.1s ease-in-out infinite; }
        
        @keyframes urgency-red {
          0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7); }
          50% { transform: scale(1.4); opacity: 0.4; box-shadow: 0 0 12px 6px rgba(239, 68, 68, 0.5); }
        }
        .animate-urgency-red { animation: urgency-red 1.5s ease-in-out infinite; }
        
        @keyframes urgency-red-fast {
          0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.8); }
          50% { transform: scale(1.5); opacity: 0.3; box-shadow: 0 0 16px 8px rgba(239, 68, 68, 0.6); }
        }
        .animate-urgency-red-fast { animation: urgency-red-fast 0.8s ease-in-out infinite; }
        
        @keyframes subtle-shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-1px); }
          75% { transform: translateX(1px); }
        }
        .animate-subtle-shake { animation: subtle-shake 3s ease-in-out infinite; }
        
        /* Scroll animations */
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out forwards;
        }
        .animate-fade-in-up-delay-1 {
          animation: fade-in-up 0.6s ease-out 0.15s forwards;
          opacity: 0;
        }
        .animate-fade-in-up-delay-2 {
          animation: fade-in-up 0.6s ease-out 0.3s forwards;
          opacity: 0;
        }
        .animate-fade-in-up-delay-3 {
          animation: fade-in-up 0.6s ease-out 0.45s forwards;
          opacity: 0;
        }
        
        /* Premium shimmer effect for main button */
        @keyframes premium-shimmer {
          0% {
            transform: translateX(-100%) skewX(-15deg);
          }
          100% {
            transform: translateX(200%) skewX(-15deg);
          }
        }
        .btn-premium {
          position: relative;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(234, 179, 8, 0.2);
          transition: all 0.3s ease;
        }
        .btn-premium:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(234, 179, 8, 0.3);
          filter: brightness(1.05);
        }
        .btn-premium::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          animation: premium-shimmer 7s ease-in-out infinite;
        }
      `}</style>
      <MetaPixel data-id="element-362" />
      <SocialProofPopup data-id="element-363" />
      <StickyHeader data-id="element-364" />

      <header className="relative pt-16 pb-20 px-4 md:px-8 overflow-hidden" data-id="element-365">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-neutral-900 via-neutral-950 to-black -z-10" data-id="element-366" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-yellow-600/10 blur-[100px] rounded-full -z-10" data-id="element-367" />

        <div className="max-w-5xl mx-auto text-center space-y-6" data-id="element-368">
          <p className="text-neutral-400 font-bold tracking-widest text-xs uppercase animate-fade-in-up" data-id="element-369">
            Para herreros, fabricantes y emprendedores
          </p>

          <div className="space-y-2" data-id="element-370">
            <h1 className="flex flex-col items-center leading-none" data-id="element-371">
              <span className="text-3xl md:text-5xl font-black text-red-500 tracking-tighter uppercase mb-2 animate-fade-in-up" data-id="element-372">
                DEJÁ DE INVENTAR CADA PROYECTO
              </span>
              <span className="text-5xl md:text-7xl font-black text-white tracking-tighter uppercase animate-fade-in-up-delay-1" data-id="element-373">
                FABRICÁ MUEBLES QUE SE VENDEN
              </span>
            </h1>

            <h2 className="text-lg md:text-xl text-yellow-400 font-medium max-w-3xl mx-auto mt-6 animate-fade-in-up-delay-2" data-id="element-374">
              +600 Planos con medidas exactas, materiales definidos y criterio
              industrial
            </h2>
          </div>

          <div className="relative mx-auto max-w-md md:max-w-lg py-8 group cursor-pointer animate-fade-in-up-delay-3" onClick={() => document.getElementById('compra')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-375">
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-24 bg-yellow-500/40 blur-[50px] rounded-full" data-id="element-376" />
            <img src={MAIN_PRODUCT_IMG} alt="Maestro de Muebles Industriales Ebook" className="relative z-10 w-full drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500 ease-out" data-id="element-377" />
          </div>

          <div className="flex flex-col items-center gap-1" data-id="element-378">
            <div className="flex gap-1" data-id="element-379">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-380" />)}
            </div>
            <span className="text-yellow-500 font-medium text-sm" data-id="element-381">
              +3.200 herreros y fabricantes satisfechos
            </span>
          </div>

          <div className="flex flex-col items-center gap-8" data-id="element-382">
            <CTAButton text="QUIERO LOS PLANOS AHORA" className="py-3 text-lg" pulse={true} data-id="element-383" />
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 md:px-8 space-y-24 pb-24" data-id="element-384">
        <FearToSystemCard data-id="element-385" />
        <ProblemsSection data-id="element-386" />

        <section className="bg-neutral-900 rounded-xl p-8 md:p-12 border border-neutral-800 shadow-2xl relative overflow-hidden" data-id="element-387">
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-600/10 blur-[80px] rounded-full -z-10" data-id="element-388" />

          <div className="text-center space-y-6 mb-12" data-id="element-389">
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-none" data-id="element-390">
              Maestro de <br data-id="element-391" />
              <span className="text-yellow-500" data-id="element-392">Muebles Industriales</span>
            </h2>
            <p className="text-xl text-neutral-300 font-medium" data-id="element-393">
              Es un ebook práctico creado para una sola cosa:
            </p>
            <p className="text-2xl font-black text-white uppercase" data-id="element-394">
              Que dejes de improvisar y empieces a fabricar con confianza.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-395">
            <div className="space-y-6" data-id="element-396">
              <ScrollToBuy data-id="element-397">
                <img src={MAIN_PRODUCT_IMG} alt="Book Cover" className="w-full rounded shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-398" />
              </ScrollToBuy>

              {/* Video Preview */}
              <div className="rounded-lg overflow-hidden shadow-2xl border border-neutral-800 bg-black" data-id="element-399">
                <video src="https://cdn.magicpatterns.com/uploads/hGMRq4tpMpnBX8eU3bEx8h/mobile_web.undefined" autoPlay muted loop playsInline className="w-full h-auto block opacity-90 hover:opacity-100 transition-opacity duration-300" data-id="element-400" />
              </div>
            </div>

            <div className="space-y-4" data-id="element-401">
              <p className="text-neutral-300" data-id="element-402">
                No es un PDF de inspiración. No es motivación vacía. No es
                teoría.
              </p>
              <p className="text-white font-bold text-lg uppercase" data-id="element-403">
                Es ejecución real.
              </p>
              <p className="text-neutral-300" data-id="element-404">Un sistema para que puedas:</p>
              <ul className="space-y-3" data-id="element-405">
                {['Empezar un mueble sabiendo exactamente qué hacer', 'Ahorrar tiempo de diseño y prueba/error', 'Evitar errores caros de material y estructura', 'Repetir modelos vendibles (rentables)', 'Cotizar rápido y cobrar con seguridad'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-406">
                    <Check className="text-yellow-500 w-6 h-6 shrink-0" data-id="element-407" />
                    <span className="text-neutral-200 font-medium" data-id="element-408">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <CTAButton text="QUIERO LOS PLANOS AHORA" data-id="element-409" />
        </section>

        <ProjectsCarousel data-id="element-410" />
        <FabricarSection data-id="element-411" />
        <BenefitsAndForYouSection data-id="element-412" />
        <BonusesSection data-id="element-413" />
        <ReviewsSection data-id="element-414" />

        <div className="space-y-12" data-id="element-415">
          <CompactAccessSection data-id="element-416" />
          <DynamicPurchaseCard data-id="element-417" />
          <UpsellSection data-id="element-418" />
        </div>

        <EbookPreviewSection data-id="element-419" />

        <TrustBadge data-id="element-420" />

        <TrustSection data-id="element-421" />
        <FAQSection data-id="element-422" />
      </main>

      <footer className="bg-black border-t border-neutral-900 py-12 text-center text-neutral-600 text-sm" data-id="element-423">
        <p data-id="element-424">
          © {new Date().getFullYear()} Maestro de Muebles Industriales. Todos
          los derechos reservados.
        </p>
        <p className="mt-2" data-id="element-425">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}